import { JobSearchResultResponse } from '@doda/api-client/aspida/@types';

/**
 * 求人リストから各要素の求人IDを取得し、カンマ区切りの文字列として返す
 * @param jobList 検索された求人のリスト
 * @param limit 連結する最大要素数（先頭からの個数）
 * @returns カンマ区切りの文字列
 */
export const getCommaSeparatedJobIds = (
  jobList: JobSearchResultResponse[],
  limit: number
) => {
  if (!jobList.length || limit < 1) return '';

  const jidList = jobList
    .map((job) => job.jid)
    .filter((jid) => jid)
    .slice(0, limit);

  return jidList.join(',');
};
